import React, {useEffect, useState} from "react"

import "./Test.css"
import tableSearch from "../../assets/tableSearch.svg"
import tableRefresh from "../../assets/tableRefresh.svg"
import closeBtn from "../../assets/mobileClose.svg"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import GroupTab from "../../component/Test/GroupTab"
import SendModal from "../../component/Modal/SendModal"
import {getCode, getDateStr, retrieveData, sendRequest} from "../../common";
import {useParams} from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

function GroupComplete() {
	const {groupId} = useParams()
	const [SendOpen, setSendOpen] = useState(false)
	const showSend = () => {
		setSendOpen(true)
	}

	const [notiOpen, setNotiOpen] = useState(false)
	const showNoti = () => {
		setNotiOpen(true)
	}
	const closeNoti = () => {
		setNotiOpen(false)
	}

	const [user, setUser] = useState()

	const [applyGroups, setApplyGroups] = useState([])
	const [applyGroup, setApplyGroup] = useState()
	const [applyTests, setApplyTests] = useState([])
	const [selected, setSelected] = useState([])
	const [applyTest, setApplyTest] = useState()

	const [tests, setTests] = useState([])
	const [testId, setTestId] = useState('')
	const [isDone, setIsDone] = useState('')
	const [name, setName] = useState('')
	const [isLoading, setIsLoading] = useState(false)

	const getTests = () => {
		sendRequest('test/test/', 'GET', null, data => {
			setTests(data)
		})
	}

	const getApplyGroups = (groupId) => {
		setIsLoading(true)
		sendRequest('test/apply-group/?isMy=1&size=500', 'GET', null, data => {
			setApplyGroups(data)
			if (groupId) {
				setApplyGroup(data?.filter(item => item?.id == groupId)?.pop())
			} else if (applyGroup?.id) {
				setApplyGroup(data?.filter(item => item?.id === applyGroup?.id)?.pop())
			}
			setIsLoading(false)
		}, (data, code) => {
			setIsLoading(false)
		})
	}

	const getSentApplyTests = (user, name='') => {
		setIsLoading(true)
		sendRequest(`test/apply-test/?sender=${user?.id}&groupId=${applyGroup?.id}&isSent=True&size=1000&test=${testId}&isDone=${isDone}&name=${name}&group=단체`, 'GET', null, data => {
			setApplyTests(data)
			setIsLoading(false)
		}, (data, code) => {
			setIsLoading(false)
		})
	}

	useEffect(() => {
		getSentApplyTests(user, name)
	}, [applyGroup])

	useEffect(() => {
		getSentApplyTests(user, name)
	}, [testId, isDone])

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
		getApplyGroups(groupId)
		getTests()
	}, [groupId])

	const deleteAll = (applyTests, index) => {
		if (applyTests?.length -1 < index) {
			getApplyGroups()
			alert('모두 삭제 되었습니다. 미실시 항목은 인증코드가 반환 되었습니다.')
			return
		}

		sendRequest(`test/apply-test/${applyTests[index]?.id}/`, 'DELETE', null, data => {
			deleteAll(applyTests, index + 1)
		})
	}

	const returnCode = (applyTests, index) => {
		if (applyTests?.filter(item => !!item.isDone)?.length) {
			alert('이미 실시한 상태가 있어, 인증코드 반환이 불가 합니다.')
			return
		}

		if (applyTests?.length - 1 < index) {
			getApplyGroups()
			alert('인증코드가 모두 반환 되었습니다.')
			return
		}

		sendRequest(`test/apply-test/${applyTests[index]?.id}/`, 'DELETE', null, data => {
			returnCode(applyTests, index + 1)
		})
	}

	const onSelected = (checked, obj) => {
		if (checked) {
			selected.push(obj)
			setSelected(Object.assign([], selected))
		} else {
			const index = selected.findIndex(item => item.id === obj.id)
			if (index !== -1) {
				selected.splice(index)
				setSelected(Object.assign([], selected))
			}
		}
	}

	return (
		<>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"단체검사 인증코드"} />
					<div className="testWrap">
						<GroupTab isLast={true} />
						<section className="groupCode">
							<form name="groupCode">
								<div className="groupForm">
									<div className="formFlex">
										<div className="formWrap">
											<div className="formItem">
												<div className="formBody">
													<span className="selectWrap">
														<select name="" onChange={e => {
															setApplyGroup(applyGroups[e.target.value])
														}}
															value={applyGroups?.findIndex(item => item?.id === applyGroup?.id)}
														>
															<option defaultValue="">그룹을 선택해주세요</option>
															{applyGroups?.map((item, index) => {
																return (
																	<option value={index}>{item?.name}</option>
																)
															})}
														</select>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								{applyGroup?.id ?
									<>
										<div className="groupName">
											<h4>{applyGroup?.name}</h4>
											{/*<p>검사기간*/}
											{/*	: {getDateStr(new Date(applyGroup?.startDateTime))} ~ {getDateStr(new Date(applyGroup?.endDateTime))}</p>*/}
										</div>
									</>
									: null
								}
								<div className="tableTab">
									<div className="tableBtn">
										<button type="button" onClick={e => {
											e.preventDefault()
											deleteAll(selected, 0)
										}}>선택 삭제</button>
										<button type="button" onClick={e => {
											e.preventDefault()
											returnCode(selected, 0)
										}}>인증코드 반환</button>
										<button type="button" className="refreshBtn" onClick={getApplyGroups}>
											새로고침
										</button>
										<span>총 {applyTests?.length}건</span>
									</div>
									<div className="tableSearch">
										<span className="selectWrap">
												<select name="" onChange={e => setTestId(e.target.value)}>
													<option defaultValue="">검사 종류</option>
													{tests?.map(item => {
														return (
															<option value={item?.id}>{item?.name}</option>
														)
													})}
												</select>
											</span>
										<span className="selectWrap">
												<select name="" onChange={e => setIsDone(e.target.value)}>
													<option defaultValue="">상태</option>
													<option value={false}>미실시</option>
													<option value={true}>완료</option>
												</select>
											</span>
										<span className="selectWrap">
												<select name="">
													<option defaultValue="">이름</option>
												</select>
											</span>
										<span className="inputWrap">
												<input type="text" name="" placeholder="검색어 입력" value={name} onChange={e => setName(e.target.value)}/>
											</span>
										<button type="button" className="searchBtn" onClick={e => {
											e.preventDefault()
											getApplyGroups()
										}}>
											<img src={tableSearch} alt="검색 버튼" />
										</button>
										<button type="button" onClick={e => {
											e.preventDefault()
											setName('')
											// setTestId('')
											// setIsDone('')
											getApplyGroups()
										}}>
											<img src={tableRefresh} alt="초기화 버튼" />
										</button>
										<span className="selectWrap">
											<select name="">
												<option defaultValue="">20개씩 보기</option>
											</select>
										</span>
									</div>
								</div>
								<div className="testTableWrap">
									<table className="testTable">
										<colgroup>
											<col width="3%" />
											<col width="12%" />
											<col width="7%" />
											<col width="15%" />
											<col width="15%" />
											<col width="10%" />
											<col width="5%" />
											<col width="10%" />
											<col width="10%" />
											<col width="5%" />
											<col width="8%" />
										</colgroup>
										<thead>
											<tr>
												<th>
													<div className="formCheckbox">
														<input type="checkbox" id="tableSelect"
																	 onChange={e => {
																		 if (e.target.checked) {
																			 setSelected(applyTests)
																		 } else {
																			 setSelected([])
																		 }
																	 }}
														/>
														<label htmlFor="tableSelect"></label>
													</div>
												</th>
												<th>검사종류</th>
												<th>이름</th>
												<th>인증코드</th>
												<th>이메일</th>
												<th>휴대폰 번호</th>
												<th>상태</th>
												<th>발송일</th>
												<th>최종접속일</th>
												<th>메일/문자</th>
												<th>발송현황</th>
											</tr>
										</thead>
										<tbody>
										{applyTests?.map((item, index) => {
											return (
												<tr>
													<td>
														<div className="formCheckbox">
															<input type="checkbox" id={`tableSelect${index}`} checked={selected?.findIndex(s => s?.id === item?.id) !== -1} onChange={e => onSelected(e.target.checked, item)}/>
															<label htmlFor={`tableSelect${index}`}></label>
														</div>
													</td>
													<td>{item?.test?.name}</td>
													<td>{item?.name}</td>
													<td>{getCode(item?.code)}</td>
													<td>{item?.email}</td>
													<td>{item?.phone}</td>
													<td className="complete">{item?.isDone ? '완료' : '미실시'}</td>
													<td>{getDateStr(new Date(item?.sendDateTime))}</td>
													<td>{getDateStr(new Date(item?.user?.last_login))}</td>
													<td>메일/문자</td>
													<td>
														<button type="button" className="viewBtn" onClick={() => {
															setApplyTest(item)
															showSend()
														}}>보기</button>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>

			{notiOpen && (
				<div className="notiWrap">
					<div className="notiModal">
						<div className="modalHeader">
							<h2>알림</h2>
							<button type="button" onClick={closeNoti}>
								<img src={closeBtn} alt="팝업 닫기" />
							</button>
						</div>
						<div className="modalText">
							<span className="blue">[2rf_20230707_인컬리지]</span> <br />
							단체검사 처리가 완료되었습니다.
						</div>
						<div className="modalBtn">
							<button type="button" onClick={closeNoti}>
								확인 (닫기)
							</button>
						</div>
					</div>
				</div>
			)}

			{SendOpen && (
				<SendModal
					setSendOpen={setSendOpen}
					title1={`회 이메일 발송완료`}
					text1={`(${applyTest?.email})`}
					title2={"휴대폰 발송완료"}
					text2={`(${applyTest?.phone})`}
					info={"최대 3회까지 발송 가능합니다."}
					applyTest={applyTest}
					reload={() => getSentApplyTests(user, name)}
				/>
			)}

			{isLoading && (
				<ClipLoader
					color={'#333'}
					loading={isLoading}
					cssOverride={{
						position: "fixed",
						display: "block",
						margin: "0 auto",
						top: 300,
						left: '50%',
						zIndex: 9999999
					}}
					size={100}
					aria-label="Loading Spinner"
					data-testid="loader"
				/>
			)}

			<RightFooter />
		</>
	)
}

export default GroupComplete
